/*
 * Project: forca
 * File Created: Thursday, 7th October 2021 7:34:41 am
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React, { Component } from 'react';

import { PdfContainerComponentProps } from './PdfContainer.definition';

import { setIsPDF } from '@Store/default.store';

class PdfContainer extends Component<PdfContainerComponentProps, any> {
	bodyRef = React.createRef<HTMLInputElement>();

	constructor(props: PdfContainerComponentProps) {
		super(props);

		this.state = {
			isVisible: false,
			isSuccess: false
		};

		this.onClick = this.onClick.bind(this);

		if (props.autoSave) {
			setTimeout(() => {
				this.onClick();
			}, 2000);
		}
	}

	createPdf = () => this.props.createPdf(this.bodyRef.current);

	onClick() {
		setIsPDF(true);

		this.setState({
			isVisible: true,
			isSuccess: false
		});

		// i set this timeout because the content need to be fast showed to be able to get in the pdf
		setTimeout(() => {
			this.createPdf();
		}, 10);

		setTimeout(() => {
			this.setState({
				isVisible: false,
				isSuccess: true
			});
		}, 300);
	}

	render() {
		const {
			children,
			buttonText,
			successText,
			apiUrl,
			documentName,
			autoSave = false
		} = this.props;

		const { isVisible, isSuccess } = this.state;

		const style = {
			display: isVisible ? 'block' : 'none'
		};

		return (
			<section className="pdf-container">
				{ !autoSave && (
					<section className="pdf-toolbar">
						<button onClick={ this.onClick }>{ buttonText }</button>
					</section>
				) }
				<section className="pdf-body" style={ style } data-api-url={ apiUrl } data-document-name={ documentName } ref={ this.bodyRef }>
					{ children }
				</section>
				{ !autoSave && isSuccess && (
					<div className="WebRaadgivning-SuccesText">
						{ successText }
					</div>
				) }
			</section>
		);
	}
}

export default PdfContainer;